<!--eslint-disable-->
<template>
    <el-container>
        <el-main class="main">
            <el-dialog title="Adicionar Cliente" :visible.sync="dialogClientVisible">
                <el-form :model="newClient">
                    <el-form-item label="Id">
                        <el-input v-model="newClient.id"></el-input>
                    </el-form-item>
                    <el-form-item label="Nome">
                        <el-input v-model="newClient.name"></el-input>
                    </el-form-item>
                    <el-form-item label="Emails (separados por ;)">
                        <el-input v-model="newClient.email"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="adicionarClienteCancelado">Cancelar</el-button>
                    <el-button type="primary" @click="adicionarCliente">Adicionar</el-button>
                </span>
            </el-dialog>
            <el-dialog title="Template de email" :visible.sync="dialogEmailTemplateVisible">
                <el-form :model="emailTemplate">
                    <el-form-item label="Email remetente">
                        <el-input v-model="emailTemplate.sender"></el-input>
                    </el-form-item>
                    <el-form-item label="Destinatários além do email cadastrado do cliente (separados por ;)">
                        <el-input v-model="emailTemplate.recipients"></el-input>
                    </el-form-item>
                    <el-form-item label="Assunto">
                        <el-input v-model="emailTemplate.subject"></el-input>
                    </el-form-item>
                    <el-form-item label="Corpo do email">
                        <el-input type="textarea" v-model="emailTemplate.content"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogEmailTemplateVisible = false">Cancelar</el-button>
                    <el-button type="primary" @click="updateEmailTemplate">Salvar</el-button>
                </span>
            </el-dialog>
            <div class="header-manual">
                <span>Clientes Cadastrados</span>
                <el-button @click="showClientForm" type="primary" style="margin-left: 20px">Adicionar Cliente</el-button>
            </div>
            <span style="font-size:15px">* Arquivos cuja célula tem coloração 
                <svg width="10" height="10">
                    <rect width="10" height="10" style="fill:#3A5F65" />
                </svg> precisam ter o nome alterado para o nome da coluna.
            </span>
            <div id="column-1">
                <div id="table-clients">
                    <el-table
                        v-loading="loadingClientsTable"
                        :header-cell-class-name="tableRowClassName"
                        :data="tableClients"
                        :default-sort = "{prop: 'name', order: 'ascending'}"
                        border
                        size="mini"
                        stripe
                        :max-height="heightClientsTable">
                        <el-table-column
                            fixed
                            sortable
                            prop="id"
                            label="Id"
                            width="70"
                            align="center">
                            <template slot-scope="scope">
                                <!-- <span> {{ scope.row[scope.column.property] }} </span> -->
                                <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarCliente"></NewEditableColumn>
                            </template>
                        </el-table-column>
                        <el-table-column
                            fixed
                            sortable
                            prop="name"
                            label="Nome"
                            width="200"
                            align="center">
                            <template slot-scope="scope">
                                <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarCliente"></NewEditableColumn>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="email"
                            label="Emails cliente"
                            width="200"
                            align="center">
                            <template slot-scope="scope">
                                <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarCliente"></NewEditableColumn>
                            </template>
                        </el-table-column>
                        <el-table-column v-for="fileType in Object.keys(fileHeaders)" 
                            :key="fileType"
                            :label="fileType" 
                            align="center">
                            <el-table-column v-for="file in fileHeaders[`${fileType}`]" 
                                :key="file"
                                :label="file" 
                                width="160"
                                align="center">
                                <template slot-scope="scope">
                                    <input type="checkbox" v-model="scope.row[`${file}Checkbox`].checked" :disabled="scope.row[`${file}Checkbox`].disabled" @change="handleCheckboxChange(scope)">
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                            prop="delete"
                            width="50"
                            align="center"> 
                            <template slot-scope="scope">
                                <div class="header-details">
                                    <span @click="removerCliente(scope)"><i class="el-icon-delete"></i></span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div id="column-2">
                <div class="header-manual column-2-item">
                    <span id="uploadFileText">Upload arquivos:</span>
                    <br>
                    <span id="uploadFileText" style="font-size:12px">(O nome do arquivo deve corresponder ao nome da coluna na tabela)</span>
                </div>
                <el-upload
                    id="uploadFileDropbox"
                    class="upload-demo column-2-item"
                    drag
                    action=""
                    :http-request="onHttpRequestFile"
                    :on-remove="handleRemoveFile" 
                    :file-list="fileList"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">Arraste aqui ou <em>clique para upload</em></div>
                </el-upload>
                <el-button type="primary" icon="el-icon-close" class="column-2-item" 
                    @click="removeAllFiles">Remover todos os arquivos</el-button>
                <br>
                <el-button type="primary" icon="el-icon-edit" class="column-2-item"
                    @click="showEmailTemplateForm">Editar email template</el-button>
                <br>
                <el-button type="success" icon="el-icon-message" class="column-2-item" 
                    @click="sendEmailConfirm">Enviar emails</el-button>
            </div>
            <br style="clear:both"/>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import firebase from 'firebase/app'
import fb from '@/services/firebaseConfig'
import NewEditableColumn from '@/components/NewEditableColumn.vue'
import format from 'xml-formatter'
import regex from '@/services/regex'

const db = fb.db

function maybeRemoveFirstZero(cnpj) {
    if (cnpj.charAt(0) == '0') {
        return cnpj.substr(1)
    }
    return cnpj
}

function updateCheckboxesbyDefault(client, header) {
    return client.default ? client.default.includes(header) : false
}

export default {
    data() {
        return {
            loading: true,
            loadingClientsTable: false,
            refDate: null,
            chosenDate: new Date(),
            dialogClientVisible: false,
            dialogEmailTemplateVisible: false,
            newClient: {
                id: 0,
                name: '',
                email: ''
            },
            movFile: {
                name: '',
                content: []
            },
            emailTemplate: {
                recipients: '',
                subject: '',
                content: '',
                firebaseDocId: ''
            },
            clientsTable: [],
            fileList: [],
            fileHeaders: {
                // "XML 4.0": ["LEBLONMASTERI", "LEBLONACOESFIC", "LEBLONFIA", "LEBLONACOESII", "LEBLONPREV"],
                // // "XML 4.0": ["LEBLONFIA", "LEBLONACOESFIC", "LEBLONACOESII", "LEBLONPREV"],
                // "XML 5.0": ["LEBLON_ACOES_II", "LEBLON_FIA"],
                // "POSTALIS (LEBLON INST I FIA)": ["INST-I-FIA", "TESOURO_SELIC"],
                // "70 BRASILPREV": ["LEBLON70BR", "LEBLON 70 BR"],
                // "Fundos de liquidez": ["MELLONLIQ"],
                // "Atribuição (ativo/ setorial)": ["Attribution", "Atribuição setorial"],
                // "Carteira em PDF": ["CARTEIRAIIFIC", "CARTEIRAMASTER"],
                // "Lâmina mensal": ["Caracteristica", "Leblon Ações FIC", "Leblon Ações II FIC", "Leblon Icatu Previdência", "Leblon Institucional I FIA"],
                // "DespesasIIFICeMaster": ["DespesasIIFICeMaster"]
                "XML 4.01": ["LEBLONACOESI", "LEBLONACOESFIC", "LEBLONFIA", "LEBLONACOESII", "LEBLONPREV", "INST_I_FIA", "TESOURO_SELIC", "LEBLON70BR"],
                "XML 5.0": ["LEBLON FIA", "LEBLON ACOES II"],
                "Fundos de Liquidez": ["MELLONLIQ"],
                "Excel": ["MASTERII", "IIFIC", "LEBLON 70 BR"],
                "Carteira em PDF": ["CARTEIRAMASTERII", "CARTEIRAIIFIC", "CARTEIRA 70 BRASILPREV", "TESOURO__SELIC", "INST I FIA"],
                "Atribuição": ["Attribution", "Atribuição setorial"],
                "Lâmina Mensal": ["Característica", "Leblon Ações FIC", "Leblon Ações II FIC", "Leblon Icatu Previdência", "Leblon 70 XP", "Leblon 100 XP", "Leblon 100 Icatu", "Leblon Institucional I FIA"],
                "DespesasIIFICeMaster": ["DespesasIIFICeMaster"]
            },
            coloredColumns: ["LEBLON_ACOES_FIC", "LEBLON_FIA", "CARTEIRAIIFIC", "CARTEIRAMASTERII", "CARTEIRA 70 BRASILPREV", "CARTEIRA TESOURO SELIC", "MASTERII","IIFIC"]
        }
    },
    components: {
        NewEditableColumn
    },
    methods: {
        tableRowClassName({row, column, rowIndex, columnIndex}) {
            if (this.coloredColumns.includes(column.label)) {
                return 'coloredColumn'
            } else {
                return ''
            }
        },
        async handleCheckboxChange(scope) {
            await this.alterarCliente(0, scope)
        },
        showClientForm() {
            this.dialogClientVisible = true;
        },
        showEmailTemplateForm() {
            db.collection('emailCommercialRoutineTemplate')
                .get()
                .then(
                    q => {
                        q.forEach(doc => {
                            this.emailTemplate = {
                                sender: doc.data().sender,
                                recipients: doc.data().recipients,
                                subject: doc.data().subject,
                                content: doc.data().content,
                                firebaseDocId: doc.id
                            }
                        })
                    }
                )
            this.dialogEmailTemplateVisible = true;
        },
        adicionarClienteCancelado() {
            this.newClient = {
                id: 0,
                name: '',
                email: ''
            }
            this.dialogClientVisible = false
        },
        updateClientsTableCheckboxes(fileName, valueOfDisabledForFile, valueOfCheckedForFile = null) {
            let allFileHeaders = []
            Object.keys(this.fileHeaders).map((fileType) => {
                allFileHeaders = allFileHeaders.concat(this.fileHeaders[`${fileType}`])
            })
            this.clientsTable.forEach((client) => {
                allFileHeaders.map((header) => {
                    if (fileName.includes(header)) {
                        if (valueOfDisabledForFile() == true) { // Garantindo que checkbox nunca estará marcada quando desabilitada
                            client[`${header}Checkbox`] = {
                                checked: false,
                                disabled: true,
                            }
                        } else {
                            client[`${header}Checkbox`] = {
                                disabled: false,
                            }
                            if (valueOfCheckedForFile !== null) {
                                client[`${header}Checkbox`].checked = valueOfCheckedForFile(client, header)
                            }
                        }
                    }
                    // console.log(client.name, header, client[`${header}Checkbox`].disabled, client[`${header}Checkbox`].checked)
                })
            })
        },
        async onHttpRequestFile(file, fileList) {
            this.updateClientsTableCheckboxes(file.file.name, () => false, updateCheckboxesbyDefault)

            let fileReader = new FileReader()
            fileReader.onload = async function (fileName) {
                let text = fileReader.result.split('base64,')[1] // Pegar apenas o conteúdo em base64, sem os headers
                // Salvar no banco e alterar interface com arquivo carregado
                let saveCommercialRoutineFile = firebase.functions().httpsCallable('saveCommercialRoutineFile');
                try {
                    let result = await saveCommercialRoutineFile({fileName, content: text})
                    let filePathSegments = result.data.result._path.segments
                    let fileIdFirebase = filePathSegments[filePathSegments.length - 1] // id do elemento no firebase é o último segmento do path
                    this.fileList.push({fileData: text, name: fileName, fileIdFirebase})
                } catch (err) {
                    this.$root.$emit('showError', err, 'error')
                }
            }.bind(this, file.file.name)
            fileReader.readAsDataURL(file.file)
        },
        async handleRemoveFile(file, fileList) {
            // Verifica se há outros arquivos para a mesma coluna e, se não houver, atualiza as checkboxes
            let allFileHeaders = []
            Object.keys(this.fileHeaders).map((fileType) => {
                allFileHeaders = allFileHeaders.concat(this.fileHeaders[`${fileType}`])
            })
            let headerForDeletedFile = allFileHeaders.filter((header) => {
                return file.name.includes(header)
            })
            let othersFilesWithThisHeader = fileList.filter((file) => {
                return file.name.includes(headerForDeletedFile)
            })
            if (othersFilesWithThisHeader.length == 0){
                this.updateClientsTableCheckboxes(file.name, () => true, () => false)
            }

            // Apaga arquivo do banco de dados
            let deleteCommercialRoutineFile = firebase.functions().httpsCallable('deleteCommercialRoutineFile');
            try {
                let result = await deleteCommercialRoutineFile({fileId: file.fileIdFirebase})
                this.fileList = fileList
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
        },
        async removeAllFiles() {
            let allFiles = this.fileList
            this.fileList = []
            await Promise.all(allFiles.map(async file => {
                this.updateClientsTableCheckboxes(file.name, () => true, () => false)
                let deleteCommercialRoutineFile = firebase.functions().httpsCallable('deleteCommercialRoutineFile');
                try {
                    let result = await deleteCommercialRoutineFile({fileId: file.fileIdFirebase})
                } catch (err) {
                    this.$root.$emit('showError', err, 'error')
                }
            }))
        },
        async removerCliente(scope) {
            this.loadingClientsTable = true
            let removerCliente = firebase.functions().httpsCallable('deleteClientCommercialRoutine');
            try {
                let result = await removerCliente({id: scope.row.docId})
                this.loadingClientsTable = false
            } catch (err) {
                this.$root.$emit('showError', "Erro. Entre em contato com o administrador do site.", 'error')
                this.loadingClientsTable = false
            }
        },
        async alterarCliente(value, scope) {
            let allFileHeaders = []
            Object.keys(this.fileHeaders).map((fileType) => {
                allFileHeaders = allFileHeaders.concat(this.fileHeaders[`${fileType}`])
            })
            let listOfChecked = []
            allFileHeaders.map((header) => {
                if (scope.row[`${header}Checkbox`].checked) {
                    listOfChecked.push(header)
                }
            })
            console.log(listOfChecked)
            
            let scopeRowObj = {
                email: scope.row.email,
                name: scope.row.name,
                id: scope.row.id,
                docId: scope.row.docId,
                default: listOfChecked
            }

            let alterarCliente = firebase.functions().httpsCallable('updateClientCommercialRoutine');
            try {
                let result = await alterarCliente(scopeRowObj)
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
        },
        async adicionarCliente() {
            let cliente = {
                name: this.newClient.name,
                id: Number(this.newClient.id),
                email: this.newClient.email,
            }
          
            let adicionarCliente = firebase.functions().httpsCallable('addClientCommercialRoutine')
            try {
                let result = await adicionarCliente(cliente)
                this.dialogClientVisible = false
                    this.newClient = {
                    id: 0,
                    name: '',
                    email: ''
                }
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
        },
        fimDia() {
            let now = new Date(this.chosenDate)
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
        },
        inicioDia() {
            let now = new Date(this.chosenDate)
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
        },
        copyToClipboard(textToCopy) {
            let textarea = document.createElement('textarea')
            textarea.value = textToCopy
            document.body.appendChild(textarea)
            textarea.select()
            document.execCommand('copy')
            document.body.removeChild(textarea)
        },
        async updateEmailTemplate() {
            let emailTemplate = {
                sender: this.emailTemplate.sender,
                recipients: this.emailTemplate.recipients,
                subject: this.emailTemplate.subject,
                content: this.emailTemplate.content,
                docId: this.emailTemplate.firebaseDocId
            }
            
            let updateCommercialRoutineEmailTemplate = firebase.functions().httpsCallable('updateCommercialRoutineEmailTemplate')
            
            try {
                let result = await updateCommercialRoutineEmailTemplate(emailTemplate)
                this.dialogEmailTemplateVisible = false
            } catch (err) {
            }
        },
        async sendEmailConfirm() {
            this.$confirm('Você tem certeza que quer mandar emails para os clientes selecionadas?', {
                confirmButtonText: 'Enviar emails',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(async () => {
                await this.sendEmails()
                this.$message({
                    type: 'success',
                    message: 'Emails enviados'
                })
            }).catch((err) => {
                console.log({err})
                this.$message({
                    type: 'info',
                    message: 'Operação cancelada'
                });          
            });
        },
        async sendEmails() {
            await Promise.all(this.tableClients.map(async (client) => {
                let allFileHeaders = []
                Object.keys(this.fileHeaders).map((fileType) => {
                    allFileHeaders = allFileHeaders.concat(this.fileHeaders[`${fileType}`])
                })
                let attachmentForClient = []
                allFileHeaders.map((header) => {
                    if (client[`${header}Checkbox`].checked && !client[`${header}Checkbox`].disabled) { // Devo mandar esse arquivo em anexo para esse cliente
                        let fileToIncludeArArray = this.fileList.filter((file) => {
                            return file.name.includes(header)
                        })
                        attachmentForClient.push(...fileToIncludeArArray)
                    }
                })
                if (attachmentForClient.length > 0) {
                    let recipients = [...this.emailTemplate.recipients.split(';'), client.email]
                    let subject = this.emailTemplate.subject
                    let content = this.emailTemplate.content
                    let sender = this.emailTemplate.sender

                    let sendCommercialRoutineEmail = firebase.functions().httpsCallable('sendCommercialRoutineEmail')
                    let result = await sendCommercialRoutineEmail({sender, recipients, subject, content, attachment: attachmentForClient})
                }
            }))
        }
    },
    computed: {
        tableClients() {
            return this.clientsTable
        },
        heightClientsTable() {
            return window.innerHeight * 0.8
        }
    },
    async created() {
        this.loading = true
        
        db.collection('commercialCustomerRegister')
            .onSnapshot(
                q => {
                    let allFileHeaders = []
                    Object.keys(this.fileHeaders).map((fileType) => {
                        allFileHeaders = allFileHeaders.concat(this.fileHeaders[`${fileType}`])
                    })
                    let auxTable = []
                    q.forEach(doc => {
                        auxTable.push({
                            docId: doc.id,
                            id: doc.data().id,
                            name: doc.data().name,
                            email: doc.data().email,
                            default: doc.data().default,
                            ...allFileHeaders.reduce((acc, fileName) => {
                                acc[`${fileName}Checkbox`] = {
                                    disabled: true,
                                    checked: false
                                }
                                return acc
                            }, {})
                        })
                    })
                    this.clientsTable = auxTable
                    this.fileList.map((file) => {
                        this.updateClientsTableCheckboxes(file.name, () => false, updateCheckboxesbyDefault)
                    })
                }
            )
                
        db.collection('emailCommercialRoutineTemplate')
            .onSnapshot(
                q => {
                    q.forEach(doc => {
                        this.emailTemplate = {
                            sender: doc.data().sender,
                            recipients: doc.data().recipients,
                            subject: doc.data().subject,
                            content: doc.data().content,
                            firebaseDocId: doc.id
                        }
                    })
                }
            )

        db.collection('commercialRoutineFiles')
            .get()
            .then(
                q => {
                    q.forEach(doc => {
                        let content = doc.data().content
                        let fileName = doc.data().fileName

                        this.fileList.push({
                            fileData: content,
                            name: fileName,
                            fileIdFirebase: doc.id,
                        })
                        this.updateClientsTableCheckboxes(fileName, () => false, updateCheckboxesbyDefault)
                    })
                }
            )
                    
        this.loading = false
    },
}
</script>

<style>
.coloredColumn {
    background:#3A5F65 !important;
    color: rgba(255, 255, 255, 0.900);
}
</style>

<style scoped>
.el-input .el-input__inner {
    color: red;
}
.el-dialog .main-title {
    font-weight: bold;
    font-size: 22px;
}
.el-dialog .title-detail {
    font-style: italic;
    font-size: 18px;
}
.header-title {
    margin:0;
    font-weight:bold;
    font-size:14px;
    text-decoration:underline;
    color: #606266;
    height: 23px;
}
.el-header.header {
    width: 1485px;
    font-family: Calibri;
    color: #606266;
    padding: 0 10px;
    font-size: 20px;
    margin-bottom: 5px;
}
.header-manual {
    font-family: Calibri;
    color: #606266;
    font-size: 20px;
    margin-top: 20px;
    margin-bottom: 10px;
}
.header-details {
    text-align: center;
}
.el-table .cell {
    word-wrap: break-word;
}
.el-table .cell-size {
    padding: 1px 0;
    font-family: Calibri;
}
.el-main.main {
    padding: 0 10px;
}
.el-footer {
    margin-top: 20px;
    padding: 0;
}
hr { 
    display: block;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    margin-left: auto;
    margin-right: auto;
    border-style: inset;
    border-width: 1px;
}
.detail-date {
    font-style: italic;
    font-size: 15px;
    float: right;
}
.column-2-item {
    margin-bottom: 7px;
}
#table-clients {
    position: relative;
    margin-top: 10px;
    margin-right: 20px;
}
#column-1 {
    width: 70%; 
    float: left;
}
#column-2 {
    width: 30%; 
    float: right;
    margin-bottom: 7px;
}
#uploadFileText {
    font-size: 17px;
}
</style>